import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './FaqAccordion.scss';

const FaqAccordion = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="faq-accordion">
      {faqs.map((faq, index) => (
        <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
          <button className="faq-question" onClick={() => toggleIndex(index)}>
            <span>{faq.question}</span>
            <span className="arrow" />
          </button>
          <div className="faq-answer">
            <div className="faq-answer-inner">{faq.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

FaqAccordion.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
  })).isRequired
};

export default FaqAccordion;
